import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import cx from 'classnames';
import { Form } from 'antd';
import { contains } from 'ramda';

import { getDictionaryUrl } from 'constants/urls';
import Error from 'components/common/form/PlainError';
import { formItemLayout } from 'constants/formItemLayout';
import RequiredFieldsContext from 'components/context/RequiredFieldsContext';
import withHiddenFieldWrapper from 'components/hocs/withHiddenFieldWrapper';
import { isRequired } from 'utils/getRequiredFields';

export default WrappedField => {
    class FieldWrapper extends Component {
        static propTypes = {
            meta: PropTypes.object,
            input: PropTypes.object,
            label: PropTypes.shape({
                content: PropTypes.string,
                required: PropTypes.bool,
                text: PropTypes.node,
            }),
            loadName: PropTypes.string,
            containerClass: PropTypes.string,
            labelClass: PropTypes.string,
            fieldClass: PropTypes.string,
            style: PropTypes.object,

            labelCol: PropTypes.object,
            wrapperCol: PropTypes.object,

            notWrap: PropTypes.bool,
            notError: PropTypes.bool,
            showValidationErrors: PropTypes.bool,
            onChange: PropTypes.func,
        };

        static defaultProps = {
            label: {},
            meta: {},
            input: {},
        };

        onChange = (value, data) => {
            const { input, onChange } = this.props;

            input.onChange(value);
            onChange && onChange(value, data);
        }

        renderField() {
            const { meta, fieldClass, loadName, notError, meta: { invalid } } = this.props;
            const loadProps = loadName ? { getLoadUrl: getDictionaryUrl, loadName } : {};

            return (
                <div className={fieldClass}>
                    <WrappedField
                        {...this.props}
                        {...loadProps}
                        onChange={this.onChange}
                    />
                    { !notError && invalid && this.showErrors() && <Error {...meta} /> }
                </div>
            );
        }

        renderWithWrap() {
            const {
                label: { content, text, required },
                labelClass, labelCol, wrapperCol,
                input: { name }
            } = this.props;

            return (
                <RequiredFieldsContext.Consumer>
                    { fields => (
                        <Form.Item
                            labelCol={labelCol || formItemLayout.labelCol}
                            wrapperCol={wrapperCol || formItemLayout.wrapperCol}
                            label={text || content && <Translate content={content}/>}
                            className={labelClass}
                            required={contains(name, fields) || required}
                        >
                            { this.renderField() }
                        </Form.Item>
                    )}
                </RequiredFieldsContext.Consumer>
            );
        }

        showErrors = () => {
            const { showValidationErrors, meta } = this.props;
            return meta.submitFailed || showValidationErrors && !isRequired(meta.error);
        }

        render() {
            const { notWrap, containerClass, meta, style } = this.props;

            const classes = cx(containerClass, {
                'has-error': meta.invalid && this.showErrors(),
                'invalid': meta.invalid
            });

            return (
                <div className={classes} style={style}>
                    { notWrap ? this.renderField() : this.renderWithWrap()}
                </div>
            );
        }
    }

    return withHiddenFieldWrapper(FieldWrapper);
}
